<template>
    <div class="search-container">
        <form action="">
            <label>
                <input type="text" placeholder="Search" name="search">
            </label>
        </form>
    </div>
</template>

<script>
export default {
    name: "SearchBar"
}
</script>

<style scoped>

</style>
